import { License, type LicenseRepository } from '@telespot/domain';
import { ParseBaseRepository } from '../../parse-base.repository';
import { LicenseTopology, ParseLicenseMapper } from './parse-license.mapper';

export class ParseLicenseRepository extends ParseBaseRepository implements LicenseRepository {
  private readonly licenseMapper = new ParseLicenseMapper(this.parse);

  public async get(): Promise<License[]> {
    const licenses = await new this.parse.Query(LicenseTopology.TABLE).find(this.options);
    return licenses.map((license) => this.licenseMapper.toDomain(license));
  }
}
